import styled from "styled-components"

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.amarillo};
  color: ${({ theme }) => theme.colors.azul};
  padding: 2rem 0 4rem;

  @media (max-width: 640px) {
    padding: 2rem 1rem 3rem;
    .card {
      padding: 0.5rem 1.2rem;
    }
  }

  h2 {
    margin-top: 0;
    margin-bottom: 2rem;
    font-family: "aller";
    font-size: clamp(1.5rem, 3vw, 2.4rem);
    text-align: center;
    &::after {
      content: "";
      width: 100%;
      height: 3px;
      background-color: ${({ theme }) => theme.colors.azul};
      display: block;
    }
  }

  .card {
    background-color: white;
    border-radius: 20px;
    padding: 1rem 2rem;
    box-shadow: 0 8px 24px rgba(0, 40, 86, 0.18);
    max-width: 800px;
    margin: 0 auto;
  }

  .row {
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 1.5rem;
    padding: 1rem 0;

    & + .row {
      border-top: 1px solid #E0E0E0;
    }

    .row__brand {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      .brand__name {
        font-family: "aller";
        font-weight: bold;
        color: ${({ theme }) => theme.colors.azul};
        font-size: 1.1rem;
        text-transform: uppercase;
      }
      .brand__model {
        color: #454545;
        font-size: 0.95rem;
      }
    }

    .row__icon {
      display: flex;
      justify-content: center;
      svg {
        width: 50px;
        height: 50px;
        color: ${({ theme }) => theme.colors.azul};
      }
    }
  }

  @media (max-width: 600px) {
    .row {
      grid-template-columns: 1fr;
      justify-items: center;
      text-align: center;
      gap: 0.8rem;
      .row__brand {
        align-items: center;
      }
      .row__icon {
        display: none;
      }
    }
  }
`
